import { motion } from "framer-motion";
import { Building2, User, Server, ShieldCheck, Cookie, Copyright } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const sections = [
  {
    icon: Building2,
    title: "Éditeur du site",
    testid: "legal-publisher",
    content: [
      "Dénomination sociale : LEVI ONE",
      "Forme juridique : SAS (Société par Actions Simplifiée)",
      "SIRET : 994 398 402 00010",
      "Siège social : 45 Allée Arthur Rimbaud, 95350 Saint-Brice-sous-Forêt, France",
      "Téléphone : 07 66 65 37 36",
      "E-mail : contact@levi-one.fr",
    ],
  },
  {
    icon: User,
    title: "Directeur de la publication",
    testid: "legal-director",
    content: ["Le directeur de la publication du site est Monsieur Dylan Parienti."],
  },
  {
    icon: Server,
    title: "Hébergement",
    testid: "legal-hosting",
    content: [
      "Le site est hébergé par Emergent, plateforme d'hébergement et de déploiement d'applications web.",
      "Site de l'hébergeur : emergentagent.com",
    ],
  },
  {
    icon: Copyright,
    title: "Propriété intellectuelle",
    testid: "legal-ip",
    content: [
      "L'ensemble des contenus du site (textes, logo, éléments graphiques, structure) est la propriété exclusive de LEVI ONE, sauf mention contraire.",
      "Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable de LEVI ONE est interdite et constituerait une contrefaçon au sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Données personnelles (RGPD)",
    testid: "legal-rgpd",
    content: [
      "Responsable de traitement : LEVI ONE, 45 Allée Arthur Rimbaud, 95350 Saint-Brice-sous-Forêt.",
      "Les données collectées via le formulaire de contact (nom, société, adresse e-mail, téléphone, message) sont utilisées uniquement pour répondre à votre demande et assurer le suivi de la relation commerciale.",
      "Base légale : mesures précontractuelles et intérêt légitime. Durée de conservation : 3 ans à compter du dernier contact. Vos données ne sont ni vendues, ni cédées à des tiers à des fins commerciales.",
      "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de vos données. Pour l'exercer : contact@levi-one.fr.",
      "Vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
  {
    icon: Cookie,
    title: "Cookies",
    testid: "legal-cookies",
    content: [
      "Ce site n'utilise aucun cookie publicitaire ou de suivi. Seuls des éléments techniques strictement nécessaires à son fonctionnement et à sa sécurité sont utilisés.",
    ],
  },
];

export default function Legal() {
  return (
    <div data-testid="legal-page">
      <section className="relative overflow-hidden border-b border-gold/10">
        <div className="absolute inset-0 hero-glow" />
        <div className="relative max-w-7xl mx-auto px-6 sm:px-10 py-16 sm:py-20">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-gold mb-4">Informations légales</p>
            <h1 className="text-4xl sm:text-5xl font-serif font-bold tracking-tight text-white leading-[1.15]">
              Mentions <span className="gold-text">légales</span>
            </h1>
            <p className="mt-5 text-base leading-relaxed text-slate-400 max-w-2xl">
              Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la
              confiance dans l'économie numérique.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-16 space-y-6">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05}>
            <div
              data-testid={s.testid}
              className="bg-navy-800/50 border border-gold/15 rounded-2xl p-7 sm:p-9 hover:border-gold/40 transition-colors duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                  <s.icon size={18} className="text-gold-bright" />
                </span>
                <h2 className="text-xl font-medium tracking-wide text-gold-bright">{s.title}</h2>
              </div>
              <div className="space-y-2.5">
                {s.content.map((line) => (
                  <p key={line} className="text-sm leading-relaxed text-slate-400">{line}</p>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
        <p className="text-xs text-slate-500 text-center pt-4">Dernière mise à jour : septembre 2026</p>
      </section>
    </div>
  );
}
